import { ApiLaydownLogRow } from './ApiLaydownLogRow';

export class GetLaydownLogsResponse {
    public constructor(init?: Partial<GetLaydownLogsResponse>) {
        Object.assign(this, init);
    }

    totalRowCount: number = 0;
    logList: ApiLaydownLogRow[] = [];
}